import { Coordinate } from 'ol/coordinate';

export class SegmentPoint {

    /**
     * 
     * @param id the identifier
     * @param x the longitude
     * @param y the latitude
     * @param elevation the local elevation
     * @param distanceFromStart the distance from the first point
     * @param slope the local gradietn in %
     * @param gradient an array of positive and negative gradients from the start point
     * @param estimatedElevation tell that the elevation is an estimation and can be overwrite
     */
    constructor(private id: number, private x: number, private y: number, private elevation: number = -0.1, private distanceFromStart: number = 0, private slope: number = 0, private gradient: number[] = [0,0], private estimatedElevation: boolean = true) {
    }

    getId() {
        return this.id;
    }

    getX() {
        return this.x;
    }

    getY() {
        return this.y;
    }

    getCoordinate(): Coordinate {
        return [this.x, this.y];
    }

    getDistanceFromStart() {
        return this.distanceFromStart;
    }

    setDistanceFromStart(distanceFromStart: number) {
        this.distanceFromStart = distanceFromStart;
    }

    getElevation() {
        return this.elevation;
    }

    setElevation(elevation: number) {
        this.elevation = elevation;
    }

    getSlope() {
        return this.slope;
    }

    setSlope(slope: number) {
        this.slope = slope;
    }

    getGradient() {
        return this.gradient;
    }

    setGradient(gradient: number[]) {
        this.gradient = gradient;
    }

    isEstimatedElevation() {
        return this.estimatedElevation;
    }

    setEstimatedElevation(interpolated: boolean) {
        this.estimatedElevation = interpolated;
    }

}